import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { apiBaseUrl } from '../../configs/configs';
import { Input, Table } from "reactstrap";
import Pagination from "react-js-pagination";
import { isEmpty } from 'lodash';

function PredictionTrasactionTable(props) {
    const [transactions, setTransaction] = useState([])
    const [totalPage, setTotalPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [mobileNumber, setMobileNumber] = useState(undefined)
    const getTransactions = async (page = 1) => {
        const result = await axios.get(`${apiBaseUrl}/transaction/predictions?page=${page}&mobile_number=${mobileNumber}`)
        if (result.data.status === 'success') {
            setTransaction(result.data.data.transactions)
            setTotalPage(result.data.data.count)
        }
    }

    const findUser = async () => {
        if(isEmpty(mobileNumber)){
            await getTransactions()
        }else if(mobileNumber.length > 10){
            alert('Mobile Number should be of 10 digits only')
        }else{
            console.log(">>", mobileNumber);
            await getTransactions()
        }
    }

    const changePage = async (page) => {
        await getTransactions(page)
        setCurrentPage(page)
    }
    

    useEffect(() => {
        getTransactions()
    }, [])
    return (
        <div>
            <div style={{display: 'flex', margin: '2rem'}}>
            <Input placeholder='phone number' maxLength={10} style={{width: '200px'}} onChange={(e) => typeof Number(e.target.value) === 'number' &&  setMobileNumber(e.target.value)}></Input>
            <button style={{marginLeft: '2rem', background: 'blue', color: '#fff', display: 'inline-block'}} onClick={findUser}>Submit</button>
            </div>
            <Table>
                <thead>
                    <tr>
                        <th>User Id</th>
                        <th>User Name</th>
                        <th>Slots</th>
                        <th>Win Distribute</th>
                        <th style={{ textAlign: 'center' }}>
                            Wallet
                            <div>
                                <span>Winning</span> &nbsp; | &nbsp;
                                <span>Deposit</span>
                            </div>
                        </th>
                        <th>
                            Winning Set
                        </th>
                        <th>
                            Reward
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.map(data => {
                        return <tr>
                            <td>{data.user_id}</td>
                            <td>{data.team_name}</td>
                            <td>{data.total_slot}</td>
                            <td>{data.win_distribute ? 'Done' : 'Not Done'}</td>
                            <td style={{ textAlign: 'center' }}>
                                <span>{data.total_wining}</span>  &nbsp; | &nbsp;
                                <span>{data.total_cash}</span>
                            </td>
                            <td>{data.is_pred_winset ? 'Done' : 'Not Done'}</td>
                            <td>{data.win_reward}</td>
                        </tr>
                    })}
                </tbody>
            </Table>
            <Pagination
                activeClass={"page-item active"}
                activeLinkClass={"page-link"}
                itemClass={"page-item"}
                linkClass={"page-link"}
                activePage={currentPage}
                itemsCountPerPage={1}
                totalItemsCount={totalPage - 1}
                pageRangeDisplayed={5}
                onChange={changePage}
            />

        </div>
    )
}

export default PredictionTrasactionTable